import PropTypes from 'prop-types';

export const Props = {
  /**
   * The theme of the ripple
   */
  theme: PropTypes.oneOf([
    'default',
    'alpha',
    'alpha_light',
    'omega',
    'omega_light',
    'white',
    'light',
    'subtle',
    'pitch',
  ]),
  /**
   * The size of the ripple
   */
  size: PropTypes.oneOf(['default', 'small', 'medium', 'large', 'extra_large']),
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
